module.exports = __webpack_public_path__ + "img/fil-rouge.4333daa7.svg";